import { useState } from 'react';
import { Button } from '@/shared/components/ui/Button';
import { useLocations } from '../hooks/useAdmin';
import { LocationsTable } from './LocationsTable';
import { LocationForm } from './LocationForm';
import type { Location } from '../services/locationsService';

export function LocationsTab() {
  const { data: locations, isLoading } = useLocations();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingLocation, setEditingLocation] = useState<Location | undefined>();

  const handleAdd = () => {
    setEditingLocation(undefined);
    setIsFormOpen(true);
  };

  const handleEdit = (location: Location) => {
    setEditingLocation(location);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setEditingLocation(undefined);
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Locations</h2>
          <p className="mt-1 text-sm text-gray-600">
            Manage practice locations and their settings
          </p>
        </div>
        <Button onClick={handleAdd}>Add Location</Button>
      </div>

      <LocationsTable
        locations={locations || []}
        onEdit={handleEdit}
        isLoading={isLoading}
      />

      <LocationForm
        isOpen={isFormOpen}
        onClose={handleClose}
        location={editingLocation}
      />
    </div>
  );
}
